import React, { useLayoutEffect } from 'react';
import styles from './EngineeringPageLoading.module.css';

export default function EngineeringPageLoading() {
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div
      className={styles.page}
      role="status"
      aria-label="採用ページを読み込み中"
    >
      <p className={styles.label}>
        Loading<span className={styles.dots}>...</span>
      </p>
    </div>
  );
}
